import { Button, ButtonPriority, ButtonSize, HoverStyles } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React from 'react';
import { ForcedState, useForcedState } from '../../../../../contexts/forced-state-context';
import { classes } from './previous-button.st.css';
const PreviousButton = ({ previousText, className, onClick })=>{
    const forcedState = useForcedState();
    const hover = forcedState.includes(ForcedState.PREVIOUS_BUTTON_HOVER);
    return /*#__PURE__*/ React.createElement(Button, {
        className: classNames(classes.previousButton, {
            [classes.previousButtonHover]: hover
        }, className),
        hoverStyle: HoverStyles.underline,
        upgrade: true,
        wrapContent: true,
        priority: ButtonPriority.basicSecondary,
        size: ButtonSize.large,
        onClick: onClick
    }, previousText);
};
export default PreviousButton;

//# sourceMappingURL=previous-button.js.map